var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-1"},[_c('router-link',{staticClass:"py-3.5 px-6 rounded flex items-center",staticStyle:{"width":"100%"},attrs:{"to":_vm.route}},[(_vm.icon)?_c('FontAwesomeIcon',{staticClass:"mr-6",attrs:{"size":"lg","icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }